import type { CSSObject } from 'styled-components';
import { defaultTheme } from '@dealstack/frontend/shared/mechanism/styleguide/defaultTheme';
import {
	DS_AI_MOTION,
	dsAiFocusRingStyles,
} from '@dealstack/frontend/app/pages/Project/Cap/DealstackAi/theme/dealstackAi.tokens';

const { colors } = defaultTheme.v3;

interface IconButtonOptions {
	variant: 'soft' | 'plain';
	/** `muted`: the design's `.icon-btn`, in the secondary ink until hovered or active. */
	tone: 'ink' | 'muted';
}

/** The design's `.icon-btn`; `size` is the call site's `w`/`h`, so it is not part of the class. */
export const iconButtonStyles = ({ variant, tone }: IconButtonOptions) =>
	({
		alignItems: 'center',
		justifyContent: 'center',
		flexShrink: 0,
		padding: 0,
		border: 'none',
		borderRadius: 4,
		color: tone === 'muted' ? colors.dark[0] : colors.dark[8],
		background: variant === 'soft' ? colors.gray[0] : 'transparent',
		cursor: 'pointer',
		transition:
			tone === 'muted'
				? `background-color ${DS_AI_MOTION.fastMs}ms ${DS_AI_MOTION.easing}, color ${DS_AI_MOTION.fastMs}ms ${DS_AI_MOTION.easing}`
				: `background-color ${DS_AI_MOTION.fastMs}ms ${DS_AI_MOTION.easing}`,
		"&:hover:not(:disabled), &[data-active='true']": {
			background: tone === 'muted' || variant === 'soft' ? colors.gray[2] : colors.gray[0],
			...(tone === 'muted' && { color: colors.dark[8] }),
		},
		'&:disabled': { cursor: 'not-allowed', opacity: 0.4 },
		...dsAiFocusRingStyles(),
	}) satisfies CSSObject;
